import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { iconChooser } from '../../helpers/IconHelper';

const useStyles = makeStyles((theme) => ({
  icon: {
    height: 30,
    width: 30,
  },
  container: {
    position: 'absolute',
    left: '-15%',
    top: '-15%',
    zIndex: theme.zIndex.drawer + 1,
  },
}));

const MarketUpperImage = ({ ...props }) => {
  const { isMkp, children } = props;
  const classes = useStyles();
  return (
    <Box position="relative">
      <Box className={classes.container}>
        <img className={classes.icon} src={iconChooser(isMkp)} />
      </Box>
      {children}
    </Box>
  );
};

MarketUpperImage.propTypes = {
  isMkp: PropTypes.bool,
  children: PropTypes.node,
};

export default MarketUpperImage;
